export const constants = {
  MAX_IMAGE_FILE_SIZE_IN_MB: 10,
  MAX_VIDEO_FILE_SIZE_IN_MB: 100,
  MAX_PDF_FILE_SIZE_IN_MB: 25,
  MAX_AUDIO_FILE_SIZE_IN_MB: 15,
};
